import React from 'react';
import cxs from 'cxs';
import { COLOURS } from '../../../../../../ui-kit/common/styles/vars';
import { Button, LabelWrapper } from '../../../../../../ui-kit';

import '../styles/_reference-field.scss';








const DISABLED = {
  background: `${COLOURS.grey.athens.parthenon} !important`,
  cursor: 'default',
  pointerEvents: 'none',
  color: `${COLOURS.grey.nevada} !important`
};

const ReferenceField = ({
  isDisabled,
  reference,
  referenceLabel,
  onChangeReference
}) =>
<div>
    <div className="reference-field">
      <LabelWrapper
      label={referenceLabel}
      className="reference-field__label">

        <div className={`reference-field__box ${cxs(isDisabled && DISABLED)}`}>
          <p className={`reference-field__box--text ${cxs(isDisabled && DISABLED)}`}>{reference}</p>
          {!isDisabled && <Button className="reference-field__box--edit-icon" onClick={onChangeReference} prefix="edit" />}
        </div>
      </LabelWrapper>
    </div>
  </div>;


ReferenceField.defaultProps = {
  isDisabled: false
};

export default ReferenceField;